(() => {
  const bars = document.querySelectorAll('[data-knytra-sticky-atc]');

  const setupMediaDots = () => {
    document.querySelectorAll('.knytra-product-page slider-component').forEach((sliderComponent) => {
      // Opt-in color galleries synchronize their own changing dot collection.
      if (sliderComponent.closest('media-gallery[data-color-gallery]')) return;
      const slider = sliderComponent.querySelector('.product__media-list');
      const slides = Array.from(slider?.querySelectorAll('.product__media-item') || []);
      const dots = Array.from(sliderComponent.querySelectorAll('.knytra-media-dot')).filter((dot, index) => {
        if (index >= slides.length) {
          dot.remove();
          return false;
        }
        return true;
      });
      const currentCounter = sliderComponent.querySelector('.slider-counter--current');
      const totalCounter = sliderComponent.querySelector('.slider-counter--total');

      if (!slider || dots.length === 0 || slides.length === 0 || slider.dataset.knytraDotsReady === 'true') return;

      slider.dataset.knytraDotsReady = 'true';
      if (totalCounter) totalCounter.textContent = String(slides.length);

      const setActiveDot = (index) => {
        if (currentCounter) currentCounter.textContent = String(index + 1);
        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          dot.toggleAttribute('aria-current', isActive);
        });
      };

      const getActiveIndex = () => {
        const slideWidth = slides[0]?.clientWidth || slider.clientWidth || 1;
        return Math.max(0, Math.min(dots.length - 1, Math.round(slider.scrollLeft / slideWidth)));
      };

      let animationFrame;
      slider.addEventListener(
        'scroll',
        () => {
          window.cancelAnimationFrame(animationFrame);
          animationFrame = window.requestAnimationFrame(() => setActiveDot(getActiveIndex()));
        },
        { passive: true }
      );

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => setActiveDot(index));
      });

      setActiveDot(0);
    });
  };

  setupMediaDots();

  if (bars.length) {
    document.body.classList.add('has-knytra-sticky-atc');
  }

  const escapeSelector = (value) => {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/"/g, '\\"');
  };

  const getStickyPriceText = (priceNode) => {
    const priceSelector = priceNode.classList.contains('price--on-sale')
      ? '.price__sale .price-item--sale.price-item--last'
      : '.price__regular .price-item--regular';
    const priceItem = priceNode.querySelector(priceSelector) || priceNode.querySelector('.price-item--last') || priceNode.querySelector('.price-item');

    return priceItem?.textContent.replace(/\s+/g, ' ').trim() || '';
  };

  bars.forEach((bar) => {
    const sectionId = bar.dataset.sectionId;
    const stickyButton = bar.querySelector('.knytra-product-sticky-atc__button');
    const stickyBuyNowButton = bar.querySelector('[data-knytra-sticky-buy-now]');
    const stickyPrice = bar.querySelector('[data-knytra-sticky-price]');
    const productInfo = document.querySelector(`#ProductInfo-${escapeSelector(sectionId)}`);

    if (!stickyButton || !productInfo) return;

    const sync = (sourceHtml) => {
      const mainButton = productInfo.querySelector('.product-form__submit');
      const paymentButton = productInfo.querySelector('.shopify-payment-button__button--unbranded');
      const priceNode = document.querySelector(`#price-${escapeSelector(sectionId)} .price`);
      const stockAlert = productInfo.querySelector('[data-knytra-stock-alert]');
      const promiseStrip = productInfo.querySelector('[data-knytra-promise-strip]');

      if (sourceHtml) {
        const sourceStockAlert = sourceHtml.querySelector('[data-knytra-stock-alert]');
        if (sourceStockAlert && stockAlert) {
          stockAlert.dataset.stockDefault = sourceStockAlert.dataset.stockDefault || '';
          stockAlert.dataset.stockSoldout = sourceStockAlert.dataset.stockSoldout || '';
          stockAlert.innerHTML = sourceStockAlert.innerHTML;
        }

        const sourcePromiseStrip = sourceHtml.querySelector('[data-knytra-promise-strip]');
        if (sourcePromiseStrip && promiseStrip) {
          promiseStrip.dataset.promiseDefault = sourcePromiseStrip.dataset.promiseDefault || '';
          promiseStrip.dataset.promiseSoldout = sourcePromiseStrip.dataset.promiseSoldout || '';
          promiseStrip.innerHTML = sourcePromiseStrip.innerHTML;
        }
      }

      if (priceNode && stickyPrice) {
        const priceText = getStickyPriceText(priceNode);
        if (priceText) stickyPrice.textContent = priceText;
      }

      if (!mainButton) return;

      const disabled = mainButton.hasAttribute('disabled') || mainButton.getAttribute('aria-disabled') === 'true';
      const label = mainButton.textContent.replace(/\s+/g, ' ').trim();
      stickyButton.disabled = disabled;
      stickyButton.textContent = disabled ? label || 'Sold out' : 'Add to cart';
      if (stickyBuyNowButton) {
        stickyBuyNowButton.disabled = disabled || !paymentButton;
      }

      if (stockAlert) {
        const defaultStockText = stockAlert.dataset.stockDefault || 'Available now - ships across India';
        const soldOutStockText = stockAlert.dataset.stockSoldout || 'Sold out - Join the next drop';
        const stockIcon = stockAlert.querySelector('span[aria-hidden="true"]')?.outerHTML || '';
        if (disabled) {
          stockAlert.textContent = soldOutStockText;
        } else {
          stockAlert.innerHTML = `${stockIcon} ${defaultStockText}`;
        }
      }

      if (promiseStrip) {
        const defaultPromiseText = promiseStrip.dataset.promiseDefault || 'Available now | Rs. 99 shipping across India | Secure checkout';
        const soldOutPromiseText = promiseStrip.dataset.promiseSoldout || 'Sold out | Join the next drop';
        promiseStrip.textContent = disabled ? soldOutPromiseText : defaultPromiseText;
      }
    };

    if (stickyBuyNowButton) {
      stickyBuyNowButton.addEventListener('click', () => {
        const paymentButton = productInfo.querySelector('.shopify-payment-button__button--unbranded');
        if (paymentButton && !paymentButton.disabled) {
          paymentButton.click();
        }
      });
    }

    sync();

    const observer = new MutationObserver(sync);
    const mainButton = productInfo.querySelector('.product-form__submit');

    if (mainButton) {
      observer.observe(mainButton, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    }

    const priceWrapper = document.querySelector(`#price-${escapeSelector(sectionId)}`);
    if (priceWrapper) {
      observer.observe(priceWrapper, {
        childList: true,
        subtree: true,
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        sync(event?.data?.html);
        setupMediaDots();
      });
    }
  });

  document.addEventListener('product-info:loaded', setupMediaDots);
  document.addEventListener('shopify:section:load', setupMediaDots);
})();
